const styles = (theme) => ({
  root: {},
  gridContainerHeader: {
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  },
  listItem: {
    padding: `${theme.spacing.unit * 2}px 0 0`,
  },
  listItemHeader: {
    padding: 0,
  },
  listItemText: {
    padding: 0,
  },
  primaryText: {
    fontSize: '1.375rem',
    fontWeight: 600,
    lineHeight: '1.125rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.688rem',
      fontWeight: 600,
      lineHeight: '1.688rem',
    },
  },
  gridItemLeft: {
    textAlign: 'left',
  },
  gridItemRight: {
    textAlign: 'right',
  },
  secondaryLabel: {
    color: theme.palette.text.dark,
    fontSize: '1.1875rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.1875rem',
    },
  },
});

export default styles;
